<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.multi_sign_list' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickCancelButton()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider ></mat-divider>
<div class="row pt-2" *ngIf="isDraftAll && !isProcess">
  <div class="col-12 subtitle">
    <span style="font-style: italic;">
      {{ thresholdContract | translate}}
    </span>
  </div>
</div>

<div class="row py-1">
  <div class="col-12">
    <span class="highligth">
      <em [innerHTML]="subtitle | translate" [ngClass]="!isDraftAll ? 'subtitle' : ''"></em>
    </span>
  </div>
  <div class="col-12">
    <span class="highligth">
      <em *ngIf="checklenghtRun" [innerHTML]="subtitle1 | translate"></em>
       <em *ngIf="!checklenghtRun" >{{'messages.sign_list_docs_draft_total_runing1' | translate}} <strong>{{listDataPopup.length}}</strong> {{'messages.sign_list_docs_draft_total_runing2' | translate}}</em>
    </span>
  </div>
</div>

<mat-dialog-content class="table-container example-container" style="max-height: 300px">
  <span *ngIf="isShowProgress" class="mx-3 mat-panel-title" style="border: none !important;">{{'search_form.processing' | translate}} {{percent}}%</span>
  <mat-progress-bar *ngIf="isShowProgress" mode="determinate" color="primary" [bufferValue] = "100" [value] = "percent">
  </mat-progress-bar>
  <mat-table [dataSource]="listData">
    <!-- STT -->
    <ng-container matColumnDef="STT">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.No' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element, let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        {{element.order ? element.order : i + 1}}
      </mat-cell>
    </ng-container>

    <!-- Tên tài liệu Column -->
    <ng-container matColumnDef="contractName">
      <mat-header-cell *matHeaderCellDef style="max-width: 30%" class="mat-cell-non-boder-right-bottom">
        {{'headertable.document_code_name' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 30%" matTooltip="{{element.contractNameCode ? element.contractNameCode :(element.name ? element.name: element.contractName) }}" class="mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        <span *ngIf="!isDraftAll" class="fix-width">{{element.contractNameCode ? element.contractNameCode : element.name}}</span>
        <span *ngIf="isDraftAll" class="fix-width">{{element.contractNameCode ? element.contractNameCode : element.contractName}}</span>
      </mat-cell>
    </ng-container>

    <!-- result Column -->
    <ng-container matColumnDef="result">
      <mat-header-cell *matHeaderCellDef style="max-width: 18%;" class="mat-cell-non-boder-right-bottom">
        {{'headertable.sign_result' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 18%;"
                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
        <span class="fix-width text-center" [ngStyle]="renderStatusColor(element.status)">{{renderStatus(element.status)}}</span>
      </mat-cell>
    </ng-container>

    <!-- Người chuyển Column -->
    <ng-container matColumnDef="detail">
      <mat-header-cell *matHeaderCellDef>
        {{'headertable.detail_sign' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ !isShowProgress ? element.errorMessage  : '' }}"
                (click)="$event.stopPropagation()" >
        <span class="fix-width">{{element.errorMessage ? element.errorMessage : ''}}</span>
      </mat-cell>
    </ng-container>


    <!-- Ngày nhận -->
    <!-- <ng-container matColumnDef="receivedTime">
        <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom" style="max-width: 12%;">{{'headertable.received_time' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" matTooltip="{{ element.receivedTime | dateformat }}"
            class="mat-cell-non-border-right-bottom number-cell-center" (click)="$event.stopPropagation()"
            style="max-width: 12%;">
            <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
        </mat-cell>
    </ng-container> -->

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
    </mat-row>
  </mat-table>
  <!-- Pagination -->
</mat-dialog-content>
<mat-divider class="mt-2"></mat-divider>

<app-pagination class="my-3" [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
</app-pagination>

<mat-dialog-actions align="center" class="action">
  <button *ngIf="!isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.cancel' | translate}}
  </button>
  <button *ngIf="!isProcess" mat-raised-button cdkFocusInitial (click)="onClickConfirmButton()" color="primary">
    <mat-icon class="mr-0">done_all</mat-icon>
    {{'button.confirm' | translate}}
  </button>
  <!-- đóng popup -->
  <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.close' | translate}}
  </button>

  <!-- dừng ký -->
  <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickStopSign()" type="button"
          [disabled] = "isStop">
    <mat-icon class="mr-0">block</mat-icon>
    {{'button.stop_progress' | translate}}
  </button>
</mat-dialog-actions>
